var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreaterequalsOutline16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83557 1.82918C4.46509 1.64393 4.01458 1.7941 3.82934 2.16459C3.6441 2.53507 3.79427 2.98557 4.16475 3.17082L10.8231 6.5L4.16475 9.82918C3.79427 10.0144 3.6441 10.4649 3.82934 10.8354C4.01458 11.2059 4.46509 11.3561 4.83557 11.1708L11.9411 7.61803C12.8625 7.15738 12.8625 5.84262 11.9411 5.38196L4.83557 1.82918ZM12.8356 10.1708C13.2061 9.98557 13.3562 9.53507 13.171 9.16459C12.9857 8.7941 12.5352 8.64393 12.1648 8.82918L4.16475 12.8292C3.79427 13.0144 3.6441 13.4649 3.82934 13.8354C4.01458 14.2059 4.46509 14.3561 4.83557 14.1708L12.8356 10.1708Z",
    fill: "#7B868C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterequalsOutline16);
export default __webpack_public_path__ + "static/media/greaterequals_outline_16.fe7fdf1d7e4fd3ebfbbd09efcb37eab7.svg";
export { ForwardRef as ReactComponent };